import { ListItemButton, ListItemIcon, ListItemText, Stack } from '@mui/material'

import { IconLogout } from '../sidebar/sidebar-nav-icons'

const quickActionSx = {
  minHeight: 48,
  px: 1.25,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  color: 'rgba(255,255,255,0.92)',
  borderRadius: 0,
  '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)' },
}

type SidebarButtonsProps = {
  close?: () => void
}

const SidebarButtons = ({ close }: SidebarButtonsProps) => {
  const logOut = () => {
    close?.()
    window.sessionStorage.removeItem('accessToken')
    window.sessionStorage.removeItem('refreshToken')
    window.sessionStorage.removeItem('userId')
    window.sessionStorage.removeItem('role')
    window.location.replace('/auth/login')
  }

  return (
    <Stack
      component="nav"
      spacing={0}
      sx={{ flexShrink: 0, pb: 1, borderTop: '1px solid rgba(255,255,255,0.12)', pt: 0.5 }}
    >
      <ListItemButton onClick={logOut} sx={quickActionSx}>
        <ListItemIcon sx={{ minWidth: 40, justifyContent: 'center', color: 'inherit' }}>
          <IconLogout size={22} />
        </ListItemIcon>
        <ListItemText
          primary="Logout"
          primaryTypographyProps={{ fontSize: 14, fontWeight: 600, noWrap: true }}
        />
      </ListItemButton>
    </Stack>
  )
}

export default SidebarButtons
